import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { Logo } from "@/components/Logo";
import { COMPANY } from "@/data/content";

export const Footer = () => (
  <footer data-testid="main-footer" className="border-t border-[#27272A] bg-[#08080A]">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
      <div className="grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <Logo height={40} />
          <p className="mt-6 text-[#A1A1AA] font-light max-w-md leading-relaxed">
            Specialist risk, intelligence and advisory services — delivering discreet, intelligence-led
            solutions to private clients, corporate organisations and high-value environments globally.
          </p>
          <p className="mt-6 text-xs tracking-[0.3em] uppercase text-[#C9A24B]">
            Understand · Advise · Protect
          </p>
        </div>

        <div>
          <h4 className="text-sm tracking-[0.2em] uppercase text-[#F5F5F0] mb-6">Navigate</h4>
          <ul className="space-y-3 text-[#A1A1AA] font-light">
            <li><Link data-testid="footer-home-link" to="/" className="hover:text-[#C9A24B] transition-colors">Home</Link></li>
            <li><Link data-testid="footer-services-link" to="/services" className="hover:text-[#C9A24B] transition-colors">Services</Link></li>
            <li><Link data-testid="footer-mission-link" to="/mission" className="hover:text-[#C9A24B] transition-colors">Our Mission</Link></li>
            <li><Link data-testid="footer-contact-link" to="/contact" className="hover:text-[#C9A24B] transition-colors">Contact</Link></li>
            <li><Link data-testid="footer-privacy-link" to="/privacy-policy" className="hover:text-[#C9A24B] transition-colors">Privacy Policy</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm tracking-[0.2em] uppercase text-[#F5F5F0] mb-6">Contact</h4>
          <ul className="space-y-4 text-[#A1A1AA] font-light">
            <li className="flex items-start gap-3">
              <Mail size={18} strokeWidth={1.4} className="text-[#C9A24B] mt-0.5 shrink-0" />
              <a data-testid="footer-email" href={`mailto:${COMPANY.email}`} className="hover:text-[#C9A24B] transition-colors break-all">{COMPANY.email}</a>
            </li>
            <li className="flex items-start gap-3">
              <Phone size={18} strokeWidth={1.4} className="text-[#C9A24B] mt-0.5 shrink-0" />
              <a href={COMPANY.phoneHref} className="hover:text-[#C9A24B] transition-colors">{COMPANY.phone}</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={18} strokeWidth={1.4} className="text-[#C9A24B] mt-0.5 shrink-0" />
              <span>{COMPANY.location}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-[#27272A] flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-[#71717A]">© {new Date().getFullYear()} Blackthorne Stratton. All rights reserved.</p>
        <p className="text-xs text-[#71717A]">Discreet · Intelligence-led · Professional · Trusted</p>
      </div>
    </div>
  </footer>
);

export default Footer;
